export const translate = key => window.__litium.translation[key] || key;

/**
 * Translates a key and replaces the {0}, {1}, ... placeholders with the given arguments.
 * Returns an empty string when the text is missing, so an untranslated key is never rendered.
 */
export const translateFormat = (key, ...args) => {
    const text = window.__litium.translation[key];
    if (!text) {
        return '';
    }
    return args.reduce((result, arg, index) => result.split(`{${index}}`).join(arg), text);
};
